import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { tap } from 'rxjs/operators';
import { HttpRequest, HttpInterceptor, HttpHandler } from '@angular/common/http';
import { AuthUserHelper } from '../helpers/auth-user.helper';

@Injectable()
export class AuthorizationInterceptorService implements HttpInterceptor {

  constructor(private authUser: AuthUserHelper, private router: Router) { }

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    // Admin auth is cookie-based (httpOnly icash_admin_token). Send credentials so the
    // cookie is attached. Only add a Bearer header when a real token exists, since a bogus
    // "Bearer undefined" header would override the cookie-based auth on the server.
    const token  = this.authUser.getToken();
    const headers: any = { 'Content-Type': 'application/json' };
    if (token && token !== 'undefined' && token !== 'null') {
        headers['Authorization'] = `Bearer ${token}`;
    }
    const newRequest = req.clone({
        setHeaders: headers,
        withCredentials: true
    });
    return next.handle(newRequest).pipe(
        tap(
            (success) => {},
            (error) => {
                if (error.status === 401 ) {
                    this.router.navigate(['/login']);
                }
            }
        )
    );
  }


}
